import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/BankingReports.css";

const cards = [
  { title: "RD/DD Report", route: "/RdDdReport", icon: "fas fa-indian-rupee-sign" },
  { title: "FD/MIS Report", route: "/FdMisReport", icon: "fas fa-piggy-bank" },
  { title: "Saving Report", route: "/SavingReport", icon: "fas fa-coins" },
  { title: "Transaction Report", route: "/TransactionReport", icon: "fas fa-sync-alt" },
  { title: "Account Closure Report", route: "/AccountClosureReport", icon: "fas fa-file-alt" },
  
];

const BankingReportsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="BankingReports-container">
      <h2 className="BankingReports-title">Banking Reports</h2>
      <div className="BankingReports-grid">
        {cards.map((card, index) => (
          <div
            key={index}
            className="BankingReports-card"
            onClick={() => navigate(card.route)}
          >
            <div className="BankingReports-card-content">
              <i className={`BankingReports-icon ${card.icon}`}></i>
              <h3>{card.title}</h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BankingReportsPage;
